import { IFeatureLoyaltyClaimPointsContentQuery } from 'generated/sanity-graphql';

export enum ClaimMethod {
  QR_SCAN = '0',
  MANUAL = '1',
}

export type ClaimPointsUIData = IFeatureLoyaltyClaimPointsContentQuery['ClaimPointsUI'];
